import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Html from './html';
import shared from './shared';
import methodModel from '../../methods/methods';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { Routes } from '../../methods/ApiRoutes';

function Offers() {
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: '',
    status: '',
    venueId: ''
  });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loaging, setLoader] = useState(false);
  const [venues, setVenues] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    getData();
    getVenues();
  }, []);

  const getData = async (params = {}) => {
    loader(true);
    const payload = {
      ...filters,
      ...params
    };

    // Remove empty filters
    Object.keys(payload).forEach(key => {
      if (payload[key] === '' || payload[key] === undefined || payload[key] === null) delete payload[key];
    });

    ApiClient.get(shared.listApi, payload).then(response => {
      loader(false);
      if (response?.success) {
        console.log(response?.data, "response?.data")
        setData(response?.data || []);
        setTotal(response?.total || 10);
      } else {
        setData([]);
        setTotal(0);
      }
    });
  };

  const getVenues = () => {
    ApiClient.get(Routes.Venue.listApi, { page: 1, count: 1000, status: 'active' }).then(res => {
      if (res.success) {
        setVenues(res.data || []);
      }
    });
  };

  const sortClass = (key) => {
    let cls = 'fa-sort';
    if (filters.key === key && filters.sorder === 'asc') cls = 'fa-sort-up';
    else if (filters.key === key && filters.sorder === 'desc') cls = 'fa-sort-down';
    return `fa ${cls}`;
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key === key && filters.sorder === 'asc') sorder = 'desc';

    const updatedFilters = {
      ...filters,
      sortBy: `${key} ${sorder}`,
      key,
      sorder,
    };

    setFilter(updatedFilters);
    getData(updatedFilters);
  };

  const clear = () => {
    const f = {
      search: '',
      status: '',
      page: 1,
      venueId: ''
    };
    const updated = { ...filters, ...f };
    setFilter({ ...updated });
    getData({ ...updated });
  };

  const filter = (p = {}) => {
    const updated = { ...filters, page: 1, ...p };
    setFilter(updated);
    getData(updated);
  };

  const deleteItem = async (id) => {
    methodModel.DeleteData(shared.deleteApi, id, shared.addTitle, getData);
  };

  const statusChange = async (itm) => {
    methodModel.StatusChange(shared.statusApi, itm, shared.title, getData);
  };

  const hotPickChange = async (itm) => {
    loader(true);
    const payload = {
      id: itm._id || itm.id,
      isHotPick: !itm.isHotPick
    };
    ApiClient.put(shared.statusApi, payload).then(res => {
      loader(false);
      if (res.success) {
        getData();
      }
    });
  };

  const pageChange = (e) => {
    const updated = { ...filters, page: e };
    setFilter(updated);
    getData(updated);
  };

  const count = (e) => {
    const updated = { ...filters, count: e, page: 1 };
    setFilter(updated);
    getData(updated);
  };

  const changeVenue = (venueId) => {
    filter({ venueId });
  };

  const changeStatus = (status) => {
    filter({ status });
  }

  const edit = (id) => {
    history(`/${shared.url}/edit/${id}`);
  };

  const view = (id) => {
    const offer = data.find(itm => itm._id === id || itm.id === id);
    setSelectedOffer(offer);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setSelectedOffer(null);
  };

  return (
    <Html
      edit={edit}
      view={view}
      clear={clear}
      sortClass={sortClass}
      sorting={sorting}
      count={count}
      pageChange={pageChange}
      deleteItem={deleteItem}
      filters={filters}
      setFilter={setFilter}
      filter={filter}
      loaging={loaging}
      data={data}
      total={total}
      statusChange={statusChange}
      hotPickChange={hotPickChange}
      venues={venues}
      changeVenue={changeVenue}
      changeStatus={changeStatus}
      selectedOffer={selectedOffer}
      isModalVisible={isModalVisible}
      closeModal={closeModal}
    />
  );
}

export default Offers;
